module.exports = __webpack_public_path__ + "static/media/cut1.a7444d47.webm";